import React from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import Modal from '../../components/Template/Modal'
import PremiumStart from '../../assets/premium/premium_start.png'
import styled from '../../theme'
import Button from '../../components/Template/Button'
import { is } from '../../components/MediaQuery'

const Header = styled.div`
  font-weight: bold;
  font-size: 18px;
`

function UpdateModal({
                       open,
                       modalId,
                       close,
                     }: {
  open?: boolean
  modalId?: string
  close?: any
}) {
  const { t } = useTranslation()
  const isDesktop = is.desktop()

  function onClose() {
    close(modalId)
  }

  return (
    <Modal
      style={{
        borderRadius: '11px',
        margin: '0 10px',
        maxWidth: '804px',
        padding: 0,
        transform: `translateY(${isDesktop ? '-20vh' : 0})`,
        width: isDesktop ? '804px' : 'unset',
      }}
      onClose={onClose}
      open={open}
    >
      <Flex full={true} row={isDesktop} columnReverse={!isDesktop}>
        <img
          style={{
            borderRadius: isDesktop ? '10px 0 0 10px' : 'unset',
            height: '250px',
            maxWidth: isDesktop ? '396px' : '410px',
            width: 'auto',
          }}
          src={PremiumStart}
          alt={'updateImg'}
        />
        <Flex
          full={true}
          justifyBetween={true}
          alignCenter={true}
          style={{ maxWidth: '410px', minHeight: '250px', padding: '1.5em' }}
          column={true}
        >
          <Header>{t('BBO_1434_title')}</Header>
          <Flex column={true}>
            <span
              style={{
                fontSize: '16px',
                lineHeight: '1.4',
                padding: '0 20px',
                textAlign: 'center',
              }}
              dangerouslySetInnerHTML={{ __html: t('BBO_1434_content') }}
            />
            <span
              style={{
                fontSize: '16px',
                lineHeight: '1.4',
                padding: '0 20px',
                textAlign: 'center',
              }}
              dangerouslySetInnerHTML={{ __html: t('BBO_1434_more_info') }}
            />
          </Flex>
          <Button onClick={onClose} style={{ width: '100%' }} primary={true}>
            {t('BBO_1434_open_calendar')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default UpdateModal
